const init = () => {
  $('.glossary-cards[data-filter="yes"]').each(function (index) {
    const $this = $(this);
    const $categorySelect = $this.find('.glossary-category-select');
    // Avoid re-initialization of event listeners
    const $categoryChangeEvent = $._data($categorySelect[0], 'events');
    if ($categoryChangeEvent && 'change' in $categoryChangeEvent) return;
    $categorySelect.change(function () {
      showSelectedSections($this);
    });
    // for mobile dropdown section select
    $this.find('.sections-list').change(function () {
      refreshCardsView($this, this.value);
    });
    // for desktop list section select
    $this.find('div.sections-list a').click(function () {
      $this.find('div.sections-list a.active').removeClass('active');
      const selectedSection = $(this);
      selectedSection.addClass('active');
      refreshCardsView($this, selectedSection.data('section'));
    });
    showSelectedSections($this);
  });
};

const showSelectedSections = ($section) => {
  const selectedCategory = $section.find('.glossary-category-select option:selected').val();
  $section.find('.sections-list').hide();
  $section.find(`.sections-list[data-category="${selectedCategory}"]`).show();

  // for mobile dropdown section select
  $section.find(`select.sections-list[data-category="${selectedCategory}"]`).val('*');

  // for desktop list section select
  $section.find('div.sections-list a.active').removeClass('active');
  $section.find(`div.sections-list[data-category="${selectedCategory}"] a`).eq(0).addClass('active');

  refreshCardsView($section);
};

const refreshCardsView = ($section, selectedSection = '*') => {
  const selectedCategory = $section.find('.glossary-category-select option:selected').val();
  $section.find('.calendar-sections div[data-category-filter][data-section-filter]').hide();
  const categoryFilter = `[data-category-filter="${selectedCategory}"]`;
  const sectionFilter = '[data-section-filter' +
    (selectedSection === '*' ? ''
      : ('="' + selectedSection + '"')
    ) + ']';
  $section.find(`.calendar-sections div${categoryFilter}${sectionFilter}`).show();
};

export default { init };
